// App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import awsconfig from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";

// Import Bootstrap CSS and JS directly here
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import AdminPage from "./AdminPage";

Amplify.configure(awsconfig);

function AppRoutes({ user, signOut }) {
  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <main className="flex-fill py-4">
        <div className="container">
          <Routes>
            <Route path="/" element={<AdminPage user={user} signOut={signOut} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Authenticator socialProviders={["google"]}>
        {({ user, signOut }) => <AppRoutes user={user} signOut={signOut} />}
      </Authenticator>
    </BrowserRouter>
  );
}

export default App;
